import { server } from "../config/server";

export const authenticateAdmin = (email, password) => {
    return fetch (`${server}/admin/login`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email,
            password
        })
    })
}

export const authorizeAdmin = (token) => {
    return fetch (`${server}/admin/profile`,{
        method: "GET",
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
}

/** logout */
export const logoutAdmin = (token) => {
    return fetch (`${server}/admin/logout`,{
        method: "POST",
        headers: {
            'Authorization': `Bearer ${token}s`
        }
    })
}